<template>
  <div class="form-container step1">
    <div class="loader" v-if="isLoading"></div>
    <form id="topup-energy-step1" @submit.prevent="submit" novalidate>
      <div class="rel">
        <div class="form-row" :class="{error: isCodeNumberError()}">
          <div class="d-flex">
            <label>Kod licznika <span class="red">*</span></label>
            <div>
              <input type="text"
                     v-model="form.code"
                     id="code"
                     @blur="validateCode"
                     @keyup="checkCode"
                     ref="code" />
            </div>
          </div>
          <div class="error" v-if="isCodeNumberError()">Podaj poprawny kod licznika</div>
        </div>
        <div class="form-row" :class="{error: isAmountError()}">
          <div class="d-flex">
            <label for="topup-amount">Deklarowana kwota zakupu <span class="red">*</span></label>
            <div>
              <input type="text"
                     id="topup-amount"
                     v-model="form.amount"
                     @change="formatAmount" />
              <span class="suffix">PLN</span>
            </div>
          </div>
          <div class="error" v-if="isAmountError()">
            Podaj kwotę doładowania
          </div>
        </div>
        <div class="form-row" v-if="isManyZones" :class="{error: isFirstAreaError() || isSecondAreaError()}">
          <div class="d-flex">
            <label>Zakup z podziałem na strefy <span class="red">*</span></label>
            <div class="zone-wrapper">
              <div>
                <div class="prefix">Strefa 1</div>
                <div class="value">
                  <input type="text"
                         v-model="form.firstArea"
                         id="firstArea"
                         @change="validateFirstArea" />
                </div>
                <div class="sufix">%</div>
              </div>
              <div>
                <div class="prefix">Strefa 2</div>
                <div class="value">
                  <input type="text"
                         v-model="form.secondArea"
                         id="secondArea"
                         @change="validateSecondArea" />
                </div>
                <div class="sufix">%</div>
              </div>
            </div>
          </div>
          <div class="error" v-if="isFirstAreaError() || isSecondAreaError()">
            Ustal podział kwoty doładowania
          </div>
        </div>
        <div class="form-row" :class="{error: isEmailError()}">
          <div class="d-flex">
            <label>Adres e-mail <span class="red">*</span></label>
            <div>
              <input type="text" v-model="form.email"
                     id="email"
                     @blur="checkEmailEmpty" />
            </div>
          </div>
          <div class="error" v-if="isEmailError()">
            Podaj poprawny adres e-mail
          </div>
        </div>
        <div class="form-row" :class="{error: isPhoneError()}">
          <div class="d-flex">
            <label>Numer telefonu komórkowego</label>
            <div>
              <input type="text"
                     v-model="form.phone"
                     id="phone"
                     @blur="checkPhoneEmpty" />
            </div>
          </div>
          <div class="error" v-if="isPhoneError()">
            Podaj poprawny numer telefonu
          </div>
        </div>
        <div class="form-row consents">
          <h3>Zgody i oświadczenia</h3>
        </div>
        <div class="form-row d-checkbox check-all">
          <div class="with-checkbox">
            <input type="checkbox" id="check-all" v-model="checkAll">
            <label for="check-all">
              <div class="mark"></div>
              <div class="text">
                <span class="check-all">Zaznacz wszystkie</span>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox" :class="{error: formSubmited && !form.agreement}">
          <div class="with-checkbox">
            <input type="checkbox" id="agreement" v-model="form.agreement">
            <label for="agreement">
              <div class="mark"></div>
              <div class="text">
                <p>Oświadczam że: <span class="red">*</span></p>
                Zapoznałem się i akceptuję <a href="/files/doladujtutaj/Regulamin_kody_energetyczne.pdf" target="_blank">Regulamin</a> świadczenia usług płatniczych oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Politykę prywatności</a>.
                Chcę, aby usługa była wykonana niezwłocznie i wiem, że nie otrzymam zwrotu poniesionych kosztów w przypadku odstąpienia od umowy.
                Jestem rezydentem Rzeczypospolitej Polskiej.
              </div>
            </label>
          </div>
          <div class="error" v-if="formSubmited && !form.agreement">Pole wymagane</div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="agreeShare" v-model="form.agreeShare">
            <label for="agreeShare">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz otrzymywać od nas mailowe, SMSowe lub telefoniczne powiadomienia o najlepszych ofertach<span v-if="!flags.showMarketing">? <a class="toggle-more" href="" @click.prevent="flags.showMarketing = true">więcej</a></span>
                  <span v-if="flags.showMarketing">, promocjach, konkursach i innych ciekawych wydarzeniach organizowanych przez nas lub naszych Partnerów? Obiecujemy nie spamować! Jeżeli nasze wiadomości Ciebie znudzą, w każdej chwili możesz wycofać zgodę.
                  <span><a href="" @click.prevent="flags.showMarketing = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="agreeContact" v-model="form.agreeContact" />
            <label for="agreeContact">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz abyśmy mogli przekazać naszym zaufanym Partnerom Twój email lub telefon<span v-if="!flags.showPartner">? <a class="toggle-more" href="" @click.prevent="flags.showPartner = true">więcej</a></span>
                  <span v-if="flags.showPartner">, aby mogli Tobie przedstawiać ciekawe informacje i oferty? Zapewniamy, że grono naszych Partnerów to uznane firmy, które tak jak my nie lubią spamować, a zgodę możesz w każdej chwili odwołać.
                  <span><a href="" @click.prevent="flags.showPartner = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row">
          <span class="red">*</span> pole wymagane
        </div>
        <div class="form-row form-buttons">
          <button type="submit" class="btn">Dalej</button>
        </div>
        <administrator-data-info />
        <div class="operator" v-if="operator">
          <img :src="getOperatorLogoSrc(operator)" :alt="operator">
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import EnergyForm from '@/common/mixins/Topup/EnergyForm.mixin'
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import { ENERGY_CODE_LENGTH } from '@/common/const/energy.const'
import { ToolsClass } from '@/common/class/tools.class'
import AdministratorDataInfo from '@/doladujtutaj/components/AdministratorDataInfo'
import { Raven } from 'vue-raven'

export default {
  name: 'TopupEnergyStep1',
  components: { AdministratorDataInfo },
  mixins: [
    EnergyForm,
    OperatorMixin
  ],
  data () {
    return {
      flags: {
        showMarketing: false,
        showPartner: false
      }
    }
  },
  computed: {
    ...mapState({
      operator: state => state.energy.checkData ? state.energy.checkData.operator : null
    })
  },
  methods: {
    ...mapMutations([
      'SET_ENERGY_CHECK_DATA',
      'SET_ENERGY_FORM_DATA',
      'SET_ENERGY_CODE_VERIFIED',
      'SET_ENERGY_CODE_ERROR'
    ]),
    ...mapActions([
      'checkEnergyAccount',
      'getEnergyCalculation'
    ]),
    validateCode () {
      if (!/^\d{16}$/.test(this.form.code)) {
        this.SET_ENERGY_CODE_ERROR(true)
      }
    },
    checkCode () {
      this.SET_ENERGY_CODE_VERIFIED(false)
      this.SET_ENERGY_CHECK_DATA(null)
      let code = this.form.code
      if (!code || code.length !== ENERGY_CODE_LENGTH) {
        return false
      }
      this.$refs['code'].blur()
      let data = {
        account: code
      }
      this.checkEnergyAccount(data)
        .then(() => {
          if (!this.isManyZones) {
            this.form.secondArea = 0
            this.calculateFirstArea()
          } else {
            this.form.secondArea = 50
            this.calculateFirstArea()
          }
        })
        .catch(error => {
          Raven.captureMessage('DoladujTutaj checkEnergyAccount error', {
            extra: {
              error: error,
              code: code
            }
          })
        })
    },
    isCodeNumberError () {
      if (this.formSubmited) {
        return !this.form.code || this.isCodeError
      }

      if (this.form.code === null) {
        return false
      }

      return this.isCodeError
    },
    isPhoneValid () {
      if (!this.form.phone || !this.form.phone.length) {
        return true
      }
      return ToolsClass.isPhoneNumberValid(this.form.phone)
    },
    scrollToLoader () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.loader'), -120, 'smooth')
      }, 100)
    },
    scrollToError () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.form-row.error'), -120, 'smooth')
      }, 100)
    },
    submit () {
      this.formSubmited = true
      this.formError = false

      if (!this.isFormValid()) {
        this.formError = true
        this.scrollToError()
        return
      }

      this.SET_ENERGY_FORM_DATA(this.form)
      let data = {
        account: this.form.code,
        amount: this.form.amount,
        percentHigh: this.form.firstArea,
        percentLow: this.form.secondArea,
        notificationPhone: this.form.phone,
        notificationEmail: this.form.email,
        agreeTerms: this.form.agreement,
        agreeContact: this.form.agreeContact,
        agreeShare: this.form.agreeShare,
        operator: this.operator
      }
      this.scrollToLoader()
      this.getEnergyCalculation(data)
        .catch(() => {
          ToolsClass.scrollToTop()
        })
    }
  },
  mounted () {
    if (this.formData !== null) {
      this.form = ToolsClass.deepExtend(this.formData)
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
